/*
  We'll add a 30-min expiry (exp) so rooms won't linger too long on your account.
  See other available options at https://docs.daily.co/reference#create-room
 */
async function createRoom() {
  const exp = Math.round(Date.now() / 1000) + 60 * 30;
  const options = {
    properties: {
      exp,
    },
  };

  const isLocal =
    process.env.REACT_APP_ROOM_ENDPOINT && process.env.REACT_APP_ROOM_ENDPOINT === 'local';
  const endpoint = isLocal
    ? 'https://api.daily.co/v1/rooms/'
    : `${window.location.origin}/api/rooms`;

  /*
    No need to send the headers with the request when using the proxy option:
    netlify.toml takes care of that for us.
  */
  const headers = isLocal && {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${process.env.REACT_APP_DAILY_API_KEY}`,
    },
  };

  const response = await fetch(endpoint, {
    method: 'POST',
    body: JSON.stringify(options),
    ...headers,
  });

  return response.json();
}

async function getRoomName(roomId) {
  const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/classroom-name?roomId=${roomId}`;

  const headers = {
    headers: {
      Accept: 'application/json',
    },
  };

  const response = await fetch(endpoint, {
    method: 'GET',
    ...headers,
  });

  return response.json();
}

async function getRoomMessages(roomId) {
  const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/classroom/messages?roomId=${roomId}`;

  const headers = {
    headers: {
      Accept: 'application/json',
    },
  };

  const response = await fetch(endpoint, {
    method: 'GET',
    ...headers,
  });

  return response.json();
}

async function sendRoomMessage(roomId, userId, participantId, senderName, message) {
  const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/classroom/messages`;

  const headers = {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  };

  const response = await fetch(endpoint, {
    method: 'POST',
    body: JSON.stringify({ roomId, userId, participantId, senderName, message }),
    ...headers,
  });

  return response.json();
}

export default { createRoom, getRoomName, getRoomMessages, sendRoomMessage };
